var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPinOren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 39,
    viewBox: "0 0 25 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9628 0.791016H12.4998H12.0367C5.37012 0.791016 0 5.70912 0 12.8545C0 18.8863 8.14782 33.548 10.5089 37.6774C10.9255 38.3732 11.6201 38.791 12.4071 38.791H12.4533H12.4995C13.2864 38.791 14.0272 38.3735 14.3976 37.6774C16.8516 33.5943 25 18.9326 25 12.9009C25 5.70945 19.5835 0.791016 12.9633 0.791016H12.9628ZM12.5001 18.9326C9.30564 18.9326 6.667 16.3344 6.667 13.0866C6.66668 9.88501 9.30564 7.28681 12.5001 7.28681C15.6945 7.28681 18.3331 9.88501 18.3331 13.1329C18.3331 16.3344 15.6942 18.9326 12.5001 18.9326Z",
    fill: "#FF9935"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOren);
export default __webpack_public_path__ + "static/media/pin-oren.b438e705c0fa8cce8fb99ad2833f3cd2.svg";
export { ForwardRef as ReactComponent };